// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   KEY MANAGEMENT CENTRAL DASHBOARD STYLES
   ========================================================================== */

.key-manage-main-wrapper {
  background-color: #f8fafc;
  min-height: 90vh;
  box-sizing: border-box;
}

.key-manage-dashboard {
  padding: 12px;
  font-family: 'Inter', system-ui, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
}

/* HEADER STYLE */
.key-manage-header {
  margin-bottom: 20px;
  text-align: center;
}

.key-manage-header h1 {
  font-size: 28px;
  color: #0f172a;
  margin: 0 0 6px 0;
  font-weight: 800;
}

.key-manage-header p {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

/* STATS GRID CONFIGURATION */
.key-manage-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
  margin-bottom: 30px;
}

.key-manage-card {
  background: #ffffff;
  padding: 24px;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.key-manage-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
}

.key-manage-card h2 {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 6px 0;
  color: #0f172a;
}

.key-manage-card p {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

/* Top Border Colors Accentuation */
.key-manage-blue { border-top: 4px solid #3b82f6; }
.key-manage-green { border-top: 4px solid #22c55e; }
.key-manage-red { border-top: 4px solid #ef4444; }
.key-manage-orange { border-top: 4px solid #f59e0b; }
.key-manage-cyan { border-top: 4px solid #06b6d4; }
.key-manage-gray { border-top: 4px solid #94a3b8; }


/* SECTION SEPARATOR FOR QUICK OPERATIONS */
.key-manage-section-title {
  margin-bottom: 20px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 12px;
  text-align: center;
}

.key-manage-section-title h3 {
  font-size: 18px;
  color: #1e293b;
  margin: 0 0 4px 0;
  font-weight: 700;
}

.key-manage-section-title p {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}


/* MODERN CARD STYLE ACTION BUTTONS STYLES */
.key-manage-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
}

.key-manage-action-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 18px;
  cursor: pointer;
  position: relative;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Icon Wrapper setup */
.key-manage-action-icon-wrapper {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.key-manage-action-icon-wrapper svg {
  width: 26px;
  height: 26px;
}

/* Action Texts Distribution */
.key-manage-action-info {
  flex: 1 1;
}

.key-manage-action-info h4 {
  font-size: 16px;
  color: #0f172a;
  margin: 0 0 6px 0;
  font-weight: 700;
}

.key-manage-action-info p {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

/* Arrow indicator on the right side */
.key-manage-action-arrow {
  font-size: 18px;
  color: #cbd5e1;
  font-weight: bold;
  transition: transform 0.2s ease, color 0.2s ease;
}

/* Dynamic Color Palettes for Individual Action Cards */

/* Clients Module Action Card */
.client-action .key-manage-action-icon-wrapper { background-color: #eff6ff; color: #2563eb; }
.client-action:hover { border-color: #2563eb; box-shadow: 0 10px 20px -5px rgba(37, 99, 235, 0.1); }
.client-action:hover .key-manage-action-icon-wrapper { background-color: #2563eb; color: #ffffff; }

/* License Module Action Card */
.license-action .key-manage-action-icon-wrapper { background-color: #f0fdf4; color: #16a34a; }
.license-action:hover { border-color: #16a34a; box-shadow: 0 10px 20px -5px rgba(22, 163, 74, 0.1); }
.license-action:hover .key-manage-action-icon-wrapper { background-color: #16a34a; color: #ffffff; }

/* Server Module Action Card */
.server-action .key-manage-action-icon-wrapper { background-color: #f6f8fa; color: #475569; }
.server-action:hover { border-color: #475569; box-shadow: 0 10px 20px -5px rgba(71, 85, 105, 0.1); }
.server-action:hover .key-manage-action-icon-wrapper { background-color: #475569; color: #ffffff; }

/* Global Hover arrow animation effect */
.key-manage-action-card:hover .key-manage-action-arrow {
  transform: translateX(4px);
  color: #0f172a;
}

/* Mobile Friendly Optimization */
@media (max-width: 640px) {
  .key-manage-action-card {
    padding: 20px;
  }
  .key-manage-action-icon-wrapper {
    width: 44px;
    height: 44px;
  }
  .key-manage-action-icon-wrapper svg {
    width: 22px;
    height: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/KeyManage/KeyManage.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC,mBAAmB,6BAA6B,EAAE;AAClD,oBAAoB,6BAA6B,EAAE;AACnD,kBAAkB,6BAA6B,EAAE;AACjD,qBAAqB,6BAA6B,EAAE;AACpD,mBAAmB,6BAA6B,EAAE;AAClD,mBAAmB,6BAA6B,EAAE;;;AAGlD,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;;AAGA,4CAA4C;AAC5C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA,uDAAuD;;AAEvD,+BAA+B;AAC/B,iDAAiD,yBAAyB,EAAE,cAAc,EAAE;AAC5F,uBAAuB,qBAAqB,EAAE,mDAAmD,EAAE;AACnG,uDAAuD,yBAAyB,EAAE,cAAc,EAAE;;AAElG,+BAA+B;AAC/B,kDAAkD,yBAAyB,EAAE,cAAc,EAAE;AAC7F,wBAAwB,qBAAqB,EAAE,mDAAmD,EAAE;AACpG,wDAAwD,yBAAyB,EAAE,cAAc,EAAE;;AAEnG,8BAA8B;AAC9B,iDAAiD,yBAAyB,EAAE,cAAc,EAAE;AAC5F,uBAAuB,qBAAqB,EAAE,mDAAmD,EAAE;AACnG,uDAAuD,yBAAyB,EAAE,cAAc,EAAE;;AAElG,wCAAwC;AACxC;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ==========================================================================\n   KEY MANAGEMENT CENTRAL DASHBOARD STYLES\n   ========================================================================== */\n\n.key-manage-main-wrapper {\n  background-color: #f8fafc;\n  min-height: 90vh;\n  box-sizing: border-box;\n}\n\n.key-manage-dashboard {\n  padding: 12px;\n  font-family: 'Inter', system-ui, sans-serif;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* HEADER STYLE */\n.key-manage-header {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.key-manage-header h1 {\n  font-size: 28px;\n  color: #0f172a;\n  margin: 0 0 6px 0;\n  font-weight: 800;\n}\n\n.key-manage-header p {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n}\n\n/* STATS GRID CONFIGURATION */\n.key-manage-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.key-manage-card {\n  background: #ffffff;\n  padding: 24px;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.key-manage-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n}\n\n.key-manage-card h2 {\n  font-size: 32px;\n  font-weight: 800;\n  margin: 0 0 6px 0;\n  color: #0f172a;\n}\n\n.key-manage-card p {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n  font-weight: 500;\n}\n\n/* Top Border Colors Accentuation */\n.key-manage-blue { border-top: 4px solid #3b82f6; }\n.key-manage-green { border-top: 4px solid #22c55e; }\n.key-manage-red { border-top: 4px solid #ef4444; }\n.key-manage-orange { border-top: 4px solid #f59e0b; }\n.key-manage-cyan { border-top: 4px solid #06b6d4; }\n.key-manage-gray { border-top: 4px solid #94a3b8; }\n\n\n/* SECTION SEPARATOR FOR QUICK OPERATIONS */\n.key-manage-section-title {\n  margin-bottom: 20px;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 12px;\n  text-align: center;\n}\n\n.key-manage-section-title h3 {\n  font-size: 18px;\n  color: #1e293b;\n  margin: 0 0 4px 0;\n  font-weight: 700;\n}\n\n.key-manage-section-title p {\n  font-size: 13px;\n  color: #94a3b8;\n  margin: 0;\n}\n\n\n/* MODERN CARD STYLE ACTION BUTTONS STYLES */\n.key-manage-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 24px;\n}\n\n.key-manage-action-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Icon Wrapper setup */\n.key-manage-action-icon-wrapper {\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n}\n\n.key-manage-action-icon-wrapper svg {\n  width: 26px;\n  height: 26px;\n}\n\n/* Action Texts Distribution */\n.key-manage-action-info {\n  flex: 1;\n}\n\n.key-manage-action-info h4 {\n  font-size: 16px;\n  color: #0f172a;\n  margin: 0 0 6px 0;\n  font-weight: 700;\n}\n\n.key-manage-action-info p {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Arrow indicator on the right side */\n.key-manage-action-arrow {\n  font-size: 18px;\n  color: #cbd5e1;\n  font-weight: bold;\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n/* Dynamic Color Palettes for Individual Action Cards */\n\n/* Clients Module Action Card */\n.client-action .key-manage-action-icon-wrapper { background-color: #eff6ff; color: #2563eb; }\n.client-action:hover { border-color: #2563eb; box-shadow: 0 10px 20px -5px rgba(37, 99, 235, 0.1); }\n.client-action:hover .key-manage-action-icon-wrapper { background-color: #2563eb; color: #ffffff; }\n\n/* License Module Action Card */\n.license-action .key-manage-action-icon-wrapper { background-color: #f0fdf4; color: #16a34a; }\n.license-action:hover { border-color: #16a34a; box-shadow: 0 10px 20px -5px rgba(22, 163, 74, 0.1); }\n.license-action:hover .key-manage-action-icon-wrapper { background-color: #16a34a; color: #ffffff; }\n\n/* Server Module Action Card */\n.server-action .key-manage-action-icon-wrapper { background-color: #f6f8fa; color: #475569; }\n.server-action:hover { border-color: #475569; box-shadow: 0 10px 20px -5px rgba(71, 85, 105, 0.1); }\n.server-action:hover .key-manage-action-icon-wrapper { background-color: #475569; color: #ffffff; }\n\n/* Global Hover arrow animation effect */\n.key-manage-action-card:hover .key-manage-action-arrow {\n  transform: translateX(4px);\n  color: #0f172a;\n}\n\n/* Mobile Friendly Optimization */\n@media (max-width: 640px) {\n  .key-manage-action-card {\n    padding: 20px;\n  }\n  .key-manage-action-icon-wrapper {\n    width: 44px;\n    height: 44px;\n  }\n  .key-manage-action-icon-wrapper svg {\n    width: 22px;\n    height: 22px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
